import React from "react";
import { STATUS_META } from "../../pages/site/seo/constants";

/** Uppercase section label used across Weave lists (matches Changes). */
export const SECTION_LABEL = "text-[11px] font-semibold uppercase tracking-[0.14em] text-theme-secondary-text";

const METHOD_COLORS = {
  GET: "bg-emerald-500/15 text-emerald-500",
  POST: "bg-sky-500/15 text-sky-500",
  PUT: "bg-amber-500/15 text-amber-500",
  PATCH: "bg-amber-500/15 text-amber-500",
  DELETE: "bg-rose-500/15 text-rose-500",
};

export const MethodBadge = ({ method }) => (
  <span
    className={`inline-flex w-12 shrink-0 justify-center rounded-md py-0.5 font-mono text-[10px] font-semibold ${
      METHOD_COLORS[method] || "bg-theme-secondary text-theme-text"
    }`}
  >
    {method}
  </span>
);

/** HTTP status as a pass/fail pill. Missing status means the request never completed. */
export const HttpStatus = ({ code }) => {
  const meta = STATUS_META[code >= 200 && code < 400 ? "pass" : "fail"];
  return (
    <span className={`inline-flex shrink-0 items-center gap-1 text-xs font-medium ${meta.text}`}>
      <meta.Icon className="h-3.5 w-3.5" />
      {code ?? "Error"}
    </span>
  );
};

export function RobotHeadIcon({ className = "h-5 w-5" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="5" y="8" width="14" height="11" rx="3" />
      <path d="M12 8V5" />
      <circle cx="12" cy="4" r="1" fill="currentColor" stroke="none" />
      <circle cx="9" cy="13" r="1.25" fill="currentColor" stroke="none" />
      <circle cx="15" cy="13" r="1.25" fill="currentColor" stroke="none" />
      <path d="M9.5 16.5h5" />
      <path d="M5 12H3.5a1 1 0 0 0 0 2H5" />
      <path d="M19 12h1.5a1 1 0 0 1 0 2H19" />
    </svg>
  );
}
